import React from "react";
import { Link } from "react-router-dom";
import { classNames } from "Utils/utils";

const VARIANT_STYLES = {
  default: {
    active: "border-indigo-400 bg-indigo-50",
    idle: "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50",
    icon: "text-indigo-600",
  },
  attention: {
    active: "border-amber-400 bg-amber-50",
    idle: "border-amber-200 bg-amber-50/40 hover:border-amber-300",
    icon: "text-amber-600",
  },
  danger: {
    active: "border-red-400 bg-red-50",
    idle: "border-red-200 bg-red-50/40 hover:border-red-300",
    icon: "text-red-600",
  },
  success: {
    active: "border-emerald-400 bg-emerald-50",
    idle: "border-emerald-200 bg-emerald-50/30 hover:border-emerald-300",
    icon: "text-emerald-600",
  },
};

const chipClassName = ({ variant, isActive, fill }) => {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.default;

  return classNames(
    "inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-left transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
    fill ? "min-w-0 flex-1" : "w-full min-w-[8.5rem]",
    isActive ? styles.active : styles.idle
  );
};

const PaCompactMetricChip = ({
  label,
  value,
  icon: Icon,
  to = null,
  onClick = null,
  hint = null,
  variant = "default",
  isActive = false,
  title = null,
  fill = true,
  className = null,
}) => {
  const content = (
    <>
      {Icon ? (
        <Icon
          className={classNames(
            "h-4 w-4 shrink-0",
            (VARIANT_STYLES[variant] || VARIANT_STYLES.default).icon
          )}
          aria-hidden="true"
        />
      ) : null}
      <span className="min-w-0 flex-1">
        <span
          className={classNames(
            "block text-xs font-medium text-gray-500",
            fill ? "truncate" : "whitespace-normal leading-tight"
          )}
        >
          {label}
        </span>
        <span className="mt-0.5 block text-lg font-semibold tabular-nums leading-tight text-gray-900">
          {value}
        </span>
        {hint ? (
          <span className="mt-0.5 block text-[10px] font-medium leading-tight text-gray-500">
            {hint}
          </span>
        ) : null}
      </span>
    </>
  );

  const classes = classNames(chipClassName({ variant, isActive, fill }), className);

  if (to) {
    return (
      <Link to={to} className={classes} title={title || label}>
        {content}
      </Link>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={typeof onClick === "function" ? isActive : undefined}
      className={classes}
      title={title || label}
    >
      {content}
    </button>
  );
};

export default PaCompactMetricChip;
